
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    COMPONENT_NAME_MAP,
    COMPONENT_NAME_MULTISCENE,
    COMPONENT_NAME_MAPMULTISCENE,
    COMPONENT_NAME_SPHEREPHOTO
} from '../../app/components/appLayout';

import PrintOptions from './PrintOptions';
import generatePdf from './generatePdf';

const PrintInternalPanel = (props) => {

    const classNames = mergeStyleSets({
        PrintInternalPanel: {
        }
    });

    const [generating, setGenerating] = useState(false);

    const [printOptions, setPrintOptions] = useState({
        orientation: 'p',
        printMap: true,
        printMultiScene: true,
        title: ''
    });

    const appLayoutComponent = useSelector(state => {
        return state.app.uiValues['AppLayoutComponent'];
    });

    const visibleMap = useSelector(state => {
        switch (appLayoutComponent) {
            case COMPONENT_NAME_MAP:
                return true;
            case COMPONENT_NAME_MULTISCENE:
                return false;
            case COMPONENT_NAME_MAPMULTISCENE:
                return true;
            case COMPONENT_NAME_SPHEREPHOTO:
                return false;
        }
    });

    const visibleMultiScene = useSelector(state => {
        switch (appLayoutComponent) {
            case COMPONENT_NAME_MAP:
                return false;
            case COMPONENT_NAME_MULTISCENE:
                return true;
            case COMPONENT_NAME_MAPMULTISCENE:
                return !!state.mapMultiScene.mapMultiScene.mmsPoint;
            case COMPONENT_NAME_SPHEREPHOTO:
                return true;
        }
    });

    const handleGeneratePdf = () => {
        setGenerating(true);
        setTimeout(() => {
            let pdf = generatePdf({
                ...printOptions,
                printMap: (printOptions.printMap && visibleMap),
                printMultiScene: (printOptions.printMultiScene && visibleMultiScene)
            });
            pdf.save('print.pdf');
            setGenerating(false);
        }, 100);
    }

    const handleChange = (options) => {
        setPrintOptions(options);
    }

    return (
        <Stack className={classNames.PrintInternalPanel} tokens={{childrenGap: 4}}>
            <Stack.Item>
                <PrintOptions
                    disabled={generating}
                    visibleMap={visibleMap}
                    visibleMultiScene={visibleMultiScene}
                    options={printOptions}
                    onChange={handleChange}
                />
            </Stack.Item>
            <Stack.Item align="end">
                <PrimaryButton disabled={generating} onClick={handleGeneratePdf}>Tisknout</PrimaryButton>
            </Stack.Item>
        </Stack>
    );
}

export default PrintInternalPanel;
